export default __webpack_public_path__ + "static/media/editor.80fcf493.gif";